
module.exports = {"attributes":{"width":"31","height":"40"},"content":"<path d=\"M31 27c0 7.3-5 13-15 13C5 40 0 32.3 0 21 0 6.4 7.9 0 18.6 0a17 17 0 0 1 9.7 2.6v1.1a12 12 0 0 0-6-1.3c-7.8 0-11 5.3-11.6 16.2a14 14 0 0 1 9.6-4c7 0 10.7 5.3 10.7 12.3zm-20-4c0 11.5 1.7 16.3 5.5 16.3 3.2 0 4.5-3.2 4.5-10.7 0-6.8-1.7-9.5-5.3-9.5-1.5 0-3.4.4-4.7 1v3z\"/>"}
var desvg = require('@kossnocorp/desvg/react')
module.exports = desvg(module.exports)
